module.exports = __webpack_public_path__ + "media/site_templates/www.localplasterers.com.au/images/feature_3-cce58fadde8806f0d02add8086cb1be6.jpeg";